import {ApexOptions} from 'apexcharts'

export const defaultOptionsChart: ApexOptions = {
  chart: {
    width: '100%',
    animations: {
      enabled: false,
    },
    toolbar: {
      show: true,
    },
    selection: {
      enabled: false,
    },
    zoom: {
      enabled: false,
    },
  },
}

export const optionsChartBar: ApexOptions = {
  chart: {
    id: 'compliance-inspections',
    type: 'line',
    ...defaultOptionsChart.chart,
  },
  plotOptions: {
    bar: {
      dataLabels: {
        position: 'top',
      },
    },
  },
  legend: {
    show: false,
  },
  stroke: {
    width: [0, 4],
  },
  xaxis: {
    type: 'category',
    categories: [],
    tooltip: {
      enabled: false,
    },
  },
  yaxis: [
    {
      axisTicks: {
        show: true,
      },
      axisBorder: {
        show: true,
      },
      labels: {
        style: {
          colors: '#008FFB',
        },
      },
      title: {
        text: 'Cantidad de inscripciones',
      },
      tooltip: {
        enabled: false,
      },
    },
    {
      opposite: true,
      title: {
        text: 'Porcentaje de cumplimiento',
      },
    },
  ],
  tooltip: {
    y: {
      formatter: function (val: any, {w, seriesIndex}) {
        if (w.config.series[seriesIndex].type === 'column') {
          return `${val}%`
        }
        return val
      },
    },
  },
  dataLabels: {
    enabled: true,
    offsetY: -10,
    formatter: function (val: any, {w, seriesIndex}) {
      if (w.config.series[seriesIndex].type === 'column') {
        return `${val}%`
      }
      return val
    },
  },
  series: [
    {
      name: 'Cantidad de inscripciones',
      type: 'column',
      data: [],
    },
    {
      name: 'Porcentaje de cumplimiento',
      type: 'line',
      data: [],
    },
  ],
}

export const optionsChartInspectionSchedule: ApexOptions = {
  chart: {
    id: 'inspections-schedule',
    type: 'line',
    ...defaultOptionsChart.chart,
  },
  plotOptions: {
    bar: {
      dataLabels: {
        position: 'top',
      },
    },
  },
  legend: {
    show: true,
  },
  xaxis: {
    type: 'category',
    categories: [],
    tooltip: {
      enabled: false,
    },
  },
  yaxis: [
    {
      show: true,
      tooltip: {
        enabled: false,
      },
    },
    {
      show: false,
    },
  ],
  tooltip: {
    y: {
      formatter: function (val: any, {w, seriesIndex}) {
        if (w.config.series[seriesIndex].type === 'line') {
          return `${val}%`
        }
        return val
      },
    },
  },
  dataLabels: {
    enabled: true,
    offsetY: -10,
    formatter: function (val: any, {w, seriesIndex, dataPointIndex}) {
      if (w.config.series[seriesIndex].type === 'line') {
        return `${val}%`
      }
      return val
    },
  },
  stroke: {
    width: [0, 0, 4],
  },
  series: [
    {
      name: 'Cantidad de inspecciones programadas',
      type: 'bar',
      data: [],
    },
    {
      name: 'Cantidad de inspecciones ejecutadas',
      type: 'bar',
      data: [],
    },
    {
      name: 'Porcentaje de cumplimiento promedio',
      type: 'line',
      data: [],
    },
  ],
}

export const optionsChartObservations: ApexOptions = {
  chart: {
    id: 'observations',
    type: 'bar',
    ...defaultOptionsChart.chart,
  },
  plotOptions: {
    bar: {
      dataLabels: {
        position: 'top',
      },
    },
  },
  legend: {
    show: true,
  },
  dataLabels: {
    enabled: true,
    offsetY: -20,
    formatter: function (val: any) {
      return val
    },
    style: {
      fontSize: '12px',
      colors: ['#304758'],
    },
  },
  xaxis: {
    type: 'category',
    categories: [],
    tooltip: {
      enabled: false,
    },
  },
  colors: ['#FCC72E', '#00B300', '#FF0808', '#008FFB'],
  series: [
    {
      name: 'Abierto',
      data: [],
    },
    {
      name: 'Cerrado',
      data: [],
    },
    {
      name: 'Abierto Pasado Fecha',
      data: [],
    },
    {
      name: 'Cerrado Pasado Fecha',
      data: [],
    },
  ],
}
